import React from 'react';
import { Route, Routes } from 'react-router';

import { ANONYM_USER_ROUTE, AUTH_USER_ROUTE } from '@/App/AppRoutes/constants';
import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { useAppSelector } from '@/App/hooks';
import { SuspenseWrapper as Suspense } from '@/components/common/SuspenseWrapper';
import { AuthProvider } from '@/hooks/AuthProvider';

const renderRoute = (route: AppRouteConfig): React.ReactElement => {
  if ('component' in route) {
    const { key, path, component: Component, lazy = true, screenRef, actionRef, selector } = route;
    const element = lazy ? (
      <Suspense>
        <Component
          screenRef={screenRef}
          actionRef={actionRef}
          getData={selector ? () => useAppSelector(selector) : undefined}
        />
      </Suspense>
    ) : (
      <Component
        screenRef={screenRef}
        actionRef={actionRef}
        getData={selector ? () => useAppSelector(selector) : undefined}
      />
    );
    return <Route key={key} path={path} element={element} />;
  }

  const { key, path, element, children } = route;
  return (
    <Route key={key} path={path} element={element}>
      {children?.map(renderRoute)}
    </Route>
  );
};

export type AppRoutesProps = { routes: AppRouteConfig[] };

export const AppRoutes: React.FC<AppRoutesProps> = ({ routes }) => (
  <AuthProvider authUserRoute={AUTH_USER_ROUTE} anonymousUserRoute={ANONYM_USER_ROUTE}>
    <Routes>{routes.map(renderRoute)}</Routes>
  </AuthProvider>
);
